import { useLocation } from 'react-router-dom';

import { orderToPrintService } from './order-invoice-printing';

import paths from 'constants/Paths';

export function usePrintManagement() {
  const currentPathname = useLocation().pathname;

  const { hasOrderToPrint } = orderToPrintService();

  const isLocationSalesSummary = currentPathname === paths.SALES_SUMMARY;
  const enableSalesSummary = !hasOrderToPrint && isLocationSalesSummary;

  return {
    enableOrderToPrint: hasOrderToPrint,
    salesSummaryPrint: enableSalesSummary,
  };
}
